import React from 'react';
import PropTypes from 'prop-types';

import Card from 'components/common/Card';
import DoughnutChart from 'components/common/DoughnutChart';
import ChartLabel from 'components/common/ChartLabel';

const HardwareChartCard = ({ hardware = [] }) => {

  const chartBackgroundColor = [
    '#7c98ab',
    '#9c9359',
    '#dbbc8e',
    '#ae8a8c',
    '#8c7386',
    '#d08d8b',
    '#766161',
    '#a9c8c0',
    '#a3cb8f',
  ];

  const getCustomLabels = () => (
    hardware.map(({ name }, index) => (
      <div
        className="column is-half-widescreen is-full-touch is-flex is-align-items-center my-1"
        key={name}
      >
        <ChartLabel
          label={name}
          color={chartBackgroundColor[index]}
        />
      </div>
    ))
  );

  return (
    <Card>
      <h3 className="has-text-weight-bold has-text-light mb-2">
        Hardware Type
      </h3>
      <div className="columns is-multiline">
        <div
          style={{ width: '100%', minHeight: 192 }}
          className="column is-12 columns is-variable is-1 is-multiline"
        >
          {getCustomLabels()}
        </div>
        <div className="column is-12">
          <DoughnutChart
            id="hardware-chart"
            data={hardware.map(hw => hw.count)}
            labels={hardware.map(hw => hw.name)}
            backgroundColor={chartBackgroundColor}
            circumference={180}
            rotation={270}
            height={150}
          />
        </div>
      </div>
    </Card>
  );
};

HardwareChartCard.propTypes = {
  hardware: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      count: PropTypes.any,
    })
  )
};

export default HardwareChartCard;
